import { apiClient } from "@/api"
import Alerter from "@/common/alerter"
import { RECEIVE_SESSIONS_OPTIONS, SCHOOL_ADMIN_MESSAGES, SCHOOL_ADMIN_PATHS } from "@/constants"
import { className } from "@/helpers/className"
import useViewport from "@/hooks/useViewport"
import React from "react"
import { Card, Col, Row } from "react-bootstrap"
import CreateOrUpdateForm from "../actions/create_or_update_form"

export const CreateSchoolAdminPageWrapper = ({ children, title, titleAffix }) => {
  const { isMobileViewport } = useViewport()
  return (
    <div className="container p-0 d-flex flex-column flex-grow-1">
      <Row>
        <Col className="p-0">
          <div className="container users-navbar_container -white justify-content-between">
            <h2 className="users-navbar_title m-0">{title}</h2>
            {titleAffix}
          </div>
          <div className="container mt-4 px-0">
            <Row className="mx-n2 px-2 mb-4">
              <Col as="main" xs={24}>
                <Card className={className(isMobileViewport ? "px-3 py-4" : "px-4 py-5")}>{children}</Card>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export const SchoolAdminNewPage = () => {
  const onSubmit = async (event, _, email, firstName, lastName, receiveSessions) => {
    event.preventDefault()

    const school_admin = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      receive_session_reports: receiveSessions === RECEIVE_SESSIONS_OPTIONS.YES,
    }

    try {
      await apiClient.post(SCHOOL_ADMIN_PATHS.apiBase, { school_admin })
      Alerter.success(SCHOOL_ADMIN_MESSAGES.createSuccess)
      window.location.replace(SCHOOL_ADMIN_PATHS.users)
    } catch (error) {
      Alerter.error(error.response.data.error)
    }
  }

  return <CreateOrUpdateForm title={"New School Admin"} onSubmit={onSubmit} />
}
